import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=19fe4a8e&scoped=true&"
import script from "./select.ts?vue&type=script&lang=ts&"
export * from "./select.ts?vue&type=script&lang=ts&"
import style0 from "./Select.vue?vue&type=style&index=0&id=19fe4a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fe4a8e",
  null
  
)

export default component.exports